import script from "./AccountsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AccountsWidget.vue?vue&type=style&index=0&id=6a79234d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a79234d"]])

export default __exports__